"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToTop = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useScrollToTop = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    (0, react_1.useLayoutEffect)(() => {
        const canControlScrollRestoration = 'scrollRestoration' in window.history;
        if (canControlScrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }, [pathname]);
};
exports.useScrollToTop = useScrollToTop;
